<template>
  <div>
    <!-- Take Catalog -->
    <vs-popup fullscreen :active.sync="catalogOk">
      <iframe id="iframe" :src="pdfLink" width="100%" height="900px"></iframe>
    </vs-popup>
    <!-- Take Catalog End-->

    <!-- Catalog -->
    <vs-popup
      fullscreen
      :title="$t('createCatalog')"
      :active.sync="popupActive"
    >
      <div class="container-fluid">
        <div class="row">
          <!-- Create Catalog Setings -->
          <div class="col-md-6">
            <div class="row">
              <!-- Settings -->
              <div class="col-md-5">
                <div class="row">
                  <div class="col-md-12">
                    <vx-card
                      :title="$t('catalogSettings')"
                      title-color="#fff"
                      content-color="#fff"
                      card-background="linear-gradient(120deg, #7f7fd5, #86a8e7, #91eae4)"
                    >
                      <label class="mt-1">{{ $t("pageSize") }}</label>
                      <v-select
                        :label="$t('pageSize')"
                        :placeholder="$t('pageSize')"
                        :closeOnSelect="true"
                        v-model="selectedPageSize"
                        :options="pagesizes"
                        @input="showPreview"
                        style="background-color: white; color: black"
                      />
                      <div class="row mt-2">
                        <div class="col-md-4">
                          <label>{{ $t("showQR") }}</label>
                          <vx-tooltip text="Tooltip Default">
                            <vs-switch v-model="ShowQR" @change="showPreview" />
                          </vx-tooltip>
                        </div>
                        <div class="col-md-4">
                          <label>{{ $t("show360") }}</label>
                          <vx-tooltip text="Tooltip Default">
                            <vs-switch
                              v-model="ShowViewLink"
                              @change="showPreview"
                            />
                          </vx-tooltip>
                        </div>
                        <div class="col-md-4">
                          <label>{{ $t("productProperties") }}</label>
                          <vx-tooltip text="Tooltip Default">
                            <vs-switch
                              v-model="ShowProps"
                              @change="showPreview"
                            />
                          </vx-tooltip>
                        </div>
                      </div>
                    </vx-card>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-md-12">
                    <vx-card
                      :title="$t('aperanceSettings')"
                      title-color="#000000"
                      content-color="#000000"
                      card-background="linear-gradient(120deg, #e2b59e, #ffd185, #ffddb4)"
                    >
                      <vs-radio
                        v-model="Use"
                        vs-name="radio2"
                        vs-value="theme"
                        @change="showPreview"
                        >{{ $t("useTheme") }}</vs-radio
                      >
                      <vs-radio
                        class="ml-2"
                        v-model="Use"
                        vs-name="radio2"
                        vs-value="color"
                        @change="showPreview"
                        >{{ $t("useColor") }}</vs-radio
                      >
                      <label class="mt-2 mb-2">{{ $t("countPerPage") }}</label>
                      <!-- Templates row -->
                      <div class="row">
                        <div class="col-md-6">
                          <div class="row">
                            <div class="col-md-2">
                              <vs-radio
                                v-model="template"
                                vs-name="radio3"
                                vs-value="0"
                                @change="showPreview"
                              ></vs-radio>
                            </div>
                            <div class="col-md-10">
                              <img
                                src="../../../assets/images/templates/template0.png"
                                alt="..."
                                class="img-thumbnail"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="row">
                            <div class="col-md-2">
                              <vs-radio
                                v-model="template"
                                vs-name="radio3"
                                vs-value="1"
                                @change="showPreview"
                              ></vs-radio>
                            </div>
                            <div class="col-md-10">
                              <img
                                src="../../../assets/images/templates/template4.png"
                                alt="..."
                                class="img-thumbnail"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-md-6">
                          <div class="row">
                            <div class="col-md-2">
                              <vs-radio
                                v-model="template"
                                vs-name="radio3"
                                vs-value="2"
                                @change="showPreview"
                              ></vs-radio>
                            </div>
                            <div class="col-md-10">
                              <img
                                src="../../../assets/images/templates/template6.png"
                                alt="..."
                                class="img-thumbnail"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="row">
                            <div class="col-md-2">
                              <vs-radio
                                v-model="template"
                                vs-name="radio3"
                                vs-value="3"
                                @change="showPreview"
                              ></vs-radio>
                            </div>
                            <div class="col-md-10">
                              <img
                                src="../../../assets/images/templates/template9.png"
                                alt="..."
                                class="img-thumbnail"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Template row end -->
                      <!-- Template row -->
                      <!-- <div class="row mt-2">
                        <div class="col-md-6">
                          <div class="row">
                            <div class="col-md-2">
                              <vs-radio
                                v-model="template"
                                vs-name="radio3"
                                vs-value="2"
                                @change="showPreview"
                              ></vs-radio>
                            </div>
                            <div class="col-md-10">
                              <img
                                src="../../../assets/images/templates/template2.png"
                                alt="..."
                                class="img-thumbnail"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="row">
                            <div class="col-md-2">
                              <vs-radio
                                v-model="template"
                                vs-name="radio3"
                                vs-value="3"
                                @change="showPreview"
                              ></vs-radio>
                            </div>
                            <div class="col-md-10">
                              <img
                                src="../../../assets/images/templates/template3.png"
                                alt="..."
                                class="img-thumbnail"
                              />
                            </div>
                          </div>
                        </div>
                      </div> -->
                      <!-- Template row end -->
                      <!-- Template row -->
                      <!-- <div class="row mt-2">
                        <div class="col-md-6">
                          <div class="row">
                            <div class="col-md-2">
                              <vs-radio
                                v-model="template"
                                vs-name="radio3"
                                vs-value="4"
                                @change="showPreview"
                              ></vs-radio>
                            </div>
                            <div class="col-md-10">
                              <img
                                src="../../../assets/images/templates/template4.png"
                                alt="..."
                                class="img-thumbnail"
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="row">
                            <div class="col-md-2">
                              <vs-radio
                                v-model="template"
                                vs-name="radio3"
                                vs-value="5"
                                @change="showPreview"
                              ></vs-radio>
                            </div>
                            <div class="col-md-10">
                              <img
                                src="../../../assets/images/templates/template5.png"
                                alt="..."
                                class="img-thumbnail"
                              />
                            </div>
                          </div>
                        </div>
                      </div> -->
                      <!-- Template row end -->
                    </vx-card>
                  </div>
                </div>
                <div class="row mt-3">
                  <vx-card
                    :title="$t('textSettings')"
                    title-color="#000000"
                    content-color="#000000"
                    card-background="linear-gradient(120deg, #e2b59e, #ffd185, #ffddb4)"
                  >
                    <vs-textarea
                      class="mb-3"
                      style="background-color: white"
                      :label="$t('firstTextEnter')"
                      v-model="FirstCustomText"
                    />
                    <vs-textarea
                      style="background-color: white"
                      :label="$t('lastTextEnter')"
                      v-model="LastCustomText"
                    />
                  </vx-card>
                </div>
                <div class="row mt-3">
                  <div class="col text-center">
                    <vs-button class="mt-2" @click="generateCatalog">{{
                      $t("generateCatalog")
                    }}</vs-button>
                  </div>
                </div>
              </div>

              <!-- Settings end -->

              <!-- Chose theme and color -->
              <div class="col-md-7">
                <vx-card>
                  <!-- theme settings -->
                  <div class="container-fluid" v-if="UseTheme">
                    <!-- theme row -->
                    <div class="row">
                      <div class="col-md-6">
                        <div class="row">
                          <div class="col-md-2">
                            <vs-radio
                              v-model="theme"
                              vs-name="radio1"
                              vs-value="0"
                              @change="showPreview"
                            ></vs-radio>
                          </div>
                          <div class="col-md-10">
                            <img
                              src="../../../assets/images/catalogs/thumb1.png"
                              alt="..."
                              class="img-thumbnail"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="row">
                          <div class="col-md-2">
                            <vs-radio
                              v-model="theme"
                              vs-name="radio1"
                              vs-value="1"
                              @change="showPreview"
                            ></vs-radio>
                          </div>
                          <div class="col-md-10">
                            <img
                              src="../../../assets/images/catalogs/thumb2.png"
                              alt="..."
                              class="img-thumbnail"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- theme row end -->
                    <!-- theme row -->
                    <!-- <div class="row mt-3">
                          <div class="col-md-6">
                              <div class="row">
                                <div class="col-md-2">
                                    <vs-radio v-model="theme" vs-name="radio1" vs-value="2"></vs-radio>
                                </div>
                                <div class="col-md-10">
                                    <img src="../../../assets/images/catalogs/thumb2.png" alt="..." class="img-thumbnail">
                                </div>
                              </div>

                          </div>
                            <div class="col-md-6">
                              <div class="row">
                                <div class="col-md-2">
                                    <vs-radio v-model="theme" vs-name="radio1" vs-value="3"></vs-radio>
                                </div>
                                <div class="col-md-10">
                                    <img src="../../../assets/images/catalogs/thumb2.png" alt="..." class="img-thumbnail">
                                </div>
                              </div>

                          </div>
                    </div>-->
                    <!-- theme row end -->
                    <!-- theme row -->
                    <!-- <div class="row mt-3">
                          <div class="col-md-6">
                              <div class="row">
                                <div class="col-md-2">
                                    <vs-radio v-model="theme" vs-name="radio1" vs-value="4"></vs-radio>
                                </div>
                                <div class="col-md-10">
                                    <img src="../../../assets/images/catalogs/thumb2.png" alt="..." class="img-thumbnail">
                                </div>
                              </div>

                          </div>
                            <div class="col-md-6">
                              <div class="row">
                                <div class="col-md-2">
                                    <vs-radio v-model="theme" vs-name="radio1" vs-value="5"></vs-radio>
                                </div>
                                <div class="col-md-10">
                                    <img src="../../../assets/images/catalogs/thumb2.png" alt="..." class="img-thumbnail">
                                </div>
                              </div>

                          </div>
                    </div>-->
                    <!-- theme row end -->
                  </div>
                  <!-- Theme settings end -->

                  <!-- Theme settings end -->

                  <!-- Color settings -->
                  <div class="container-fluid" v-if="UseColor">
                    <div class="row">
                      <div class="col-md-12">
                        <h3 class="text-center">{{ $t("frontPageColor") }}</h3>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <chrome-picker v-model="color1" @input="showPreview" />
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-md-12">
                        <h3 class="text-center">
                          {{ $t("productPageColor") }}
                        </h3>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <chrome-picker v-model="color2" @input="showPreview" />
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-md-12">
                        <h3 class="text-center">{{ $t("backPageColor") }}</h3>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <chrome-picker v-model="color3" @input="showPreview" />
                      </div>
                    </div>
                  </div>
                  <!-- Color settings end -->
                </vx-card>
              </div>
              <!-- Theme and color settings end -->
            </div>
            <div class="row" style="position: absolute; bottom: 0">
              <div class="col-md-12">
                <div style="margin-left: 610px">
                  <!-- <vs-button @click="generateCatalog">Önizle</vs-button> -->
                </div>
              </div>
            </div>
          </div>
          <!-- Generate catalog settings end -->

          <!-- Catalog preview -->
          <div class="col-md-6">
            <!-- IFrame -->
            <iframe id="iframe" src width="100%" height="1000px"></iframe>
            <!-- IFrame end -->
          </div>
          <!-- Catalog preview end -->
        </div>
      </div>
    </vs-popup>
    <!-- Catalog end -->

    <!-- Top -->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <vx-card class="mb-base">
            <div class="row justify-content-between">
              <div class="col-md-4">
                <vs-button
                  :disabled="$store.state.catalogs.length == 0"
                  @click="firstPreview"
                  >{{ $t("pdfreview") }}</vs-button
                >
              </div>
              <!-- <div class="col-md-4">
                <vs-button
                  :disabled="$store.state.catalogs.length == 0"
                  @click="removePopup = true"
                >{{ $t('clearCatalog') }}</vs-button>
              </div> -->
            </div>
          </vx-card>
        </div>
      </div>
    </div>
    <!-- Top End -->

    <!-- Product List -->
    <div class="container-fluid">
      <Products :selectedProducts="selectedProducts"></Products>
    </div>
    <!-- Product List End -->
  </div>
</template>
<script>
import http from "../../../http/http-helper";

import Products from "./CatalogComponents/Products";
import vSelect from "vue-select";
import { Chrome } from "vue-color";
export default {
  components: {
    Products,
    "v-select": vSelect,
    "chrome-picker": Chrome,
  },
  data() {
    return {
      popupActive: false,
      selectedPageCount: "4",
      selectedPageSize: "A4",
      numbers: [1, 4],
      pagesizes: ["A0", "A1", "A2", "A3", "A4", "A5"],
      selectedProducts: [],
      selectedProduct: "",
      ShowProps: true,
      UseColor: false,
      UseTheme: true,
      ShowQR: true,
      ShowViewLink: true,
      size: 0,
      pdfLink: "",
      FirstCustomText: "",
      LastCustomText: "",
      color1: "#000000",
      color2: "#000000",
      color3: "#000000",
      theme: "0",
      Use: "theme",
      template: "0",
      temp: 0,
      catalogOk: false,
    };
  },
  methods: {
    setValue() {
      if (this.Use == "theme") {
        this.UseTheme = true;
        this.UseColor = false;
      } else if (this.Use == "color") {
        this.UseColor = true;
        this.UseTheme = false;
      }
    },
    setRadioValue() {
      if (this.template == "0") {
        this.temp = 0;
      } else if (this.template == "1") {
        this.temp = 1;
      } else if (this.template == "2") {
        this.temp = 2;
      } else if (this.template == "3") {
        this.temp = 3;
      } else if (this.template == "4") {
        this.temp = 4;
      } else if (this.template == "5") {
        this.temp = 5;
      }
    },
    showPreview() {
      this.setValue();
      this.setRadioValue();
      if (this.selectedPageCount == 1) {
        this.number = 0;
      } else if (this.selectedPageCount == 4) {
        this.number = 1;
      }
      if (this.selectedPageSize == "A0") {
        this.size = 0;
      }
      if (this.selectedPageSize == "A1") {
        this.size = 1;
      }
      if (this.selectedPageSize == "A2") {
        this.size = 2;
      }
      if (this.selectedPageSize == "A3") {
        this.size = 3;
      }
      if (this.selectedPageSize == "A4") {
        this.size = 4;
      }
      if (this.selectedPageSize == "A5") {
        this.size = 5;
      }
      if (this.UseColor === true) {
        this.UseTheme = false;
        var obj = {
          ProductIds: this.selectedProducts,
          Template: this.temp,
          PaperSize: this.size,
          ShowProps: this.ShowProps,
          ShowQR: this.ShowQR,
          ShowViewLink: this.ShowViewLink,
          Theme: 0,
          BackgroundColor: [this.color1.hex, this.color2.hex, this.color3.hex],
          Preview: true,
          FirstCustomText: this.FirstCustomText,
          LastCustomText: this.LastCustomText,
        };
      } else if (this.UseTheme === true) {
        this.UseColor = false;
        if (this.theme == 0) {
          var theme = 0;
        }
        if (this.theme == 1) {
          var theme = 1;
        }
        var obj = {
          ProductIds: this.selectedProducts,
          Template: this.temp,
          PaperSize: this.size,
          ShowProps: this.ShowProps,
          ShowQR: this.ShowQR,
          ShowViewLink: this.ShowViewLink,
          Theme: theme,
          BackgroundColor: [],
          Preview: true,
          FirstCustomText: this.FirstCustomText,
          LastCustomText: this.LastCustomText,
        };
      }

      let path = "/products/generatecatalog";
      http.post(path, obj).then((response) => {
        $("#iframe").contents().find("html").html(response);
      });
    },
    firstPreview() {
      this.popupActive = true;
      var obj = {
        ProductIds: this.selectedProducts,
        Template: 0,
        PaperSize: 4,
        ShowProps: true,
        ShowQR: true,
        ShowViewLink: true,
        Theme: 0,
        BackgroundColor: [],
        Preview: true,
        FirstCustomText: this.FirstCustomText,
        LastCustomText: this.LastCustomText,
      };
      let path = "/products/generatecatalog";
      http.post(path, obj).then((response) => {
        $("#iframe").contents().find("html").html(response);
      });
    },
    generateCatalog() {
      if (this.selectedPageCount == 1) {
        this.number = 0;
      } else if (this.selectedPageCount == 4) {
        this.number = 1;
      }
      if (this.selectedPageSize == "A0") {
        this.size = 0;
      }
      if (this.selectedPageSize == "A1") {
        this.size = 1;
      }
      if (this.selectedPageSize == "A2") {
        this.size = 2;
      }
      if (this.selectedPageSize == "A3") {
        this.size = 3;
      }
      if (this.selectedPageSize == "A4") {
        this.size = 4;
      }
      if (this.selectedPageSize == "A5") {
        this.size = 5;
      }
      if (this.UseColor === true) {
        this.UseTheme = false;
        var obj = {
          ProductIds: this.selectedProducts,
          Template: this.temp,
          PaperSize: this.size,
          ShowProps: this.ShowProps,
          ShowQR: this.ShowQR,
          ShowViewLink: this.ShowViewLink,
          Theme: 0,
          BackgroundColor: [this.color1.hex, this.color2.hex, this.color3.hex],
          FirstCustomText: this.FirstCustomText,
          LastCustomText: this.LastCustomText,
        };
      } else if (this.UseTheme === true) {
        this.UseColor = false;
        if (this.theme == 0) {
          var theme = 0;
        }
        if (this.theme == 1) {
          var theme = 1;
        }
        var obj = {
          ProductIds: this.selectedProducts,
          Template: this.temp,
          PaperSize: this.size,
          ShowProps: this.ShowProps,
          ShowQR: this.ShowQR,
          ShowViewLink: this.ShowViewLink,
          Theme: theme,
          BackgroundColor: [],
          FirstCustomText: this.FirstCustomText,
          LastCustomText: this.LastCustomText,
        };
      }

      this.popupActive = true;
      let path = "/products/generatecatalog";
      http.post(path, obj).then((response) => {
        this.pdfLink = "https://api.360photoboxcloud.com/" + response;
        this.catalogOk = true;
      });
    },
  },
};
</script>
<style scoped>
.vc-chrome {
  width: inherit !important;
}
</style>